import { storyblokInit as n } from "@storyblok/js";
import { setStoryblokApiInstance as a, setComponents as m, setEnableFallbackComponent as l, setCustomFallbackComponent as b, getStoryblokApiInstance as c } from "./state.mjs";
import { getComponent as f, getCustomFallbackComponent as p, getEnableFallbackComponent as y } from "./state.mjs";
const k = (o = {}) => {
  const t = c();
  if (t)
    return () => t;
  const { storyblokApi: e } = n(o);
  return a(e), o.components && m(o.components), o.enableFallbackComponent !== void 0 && l(o.enableFallbackComponent), o.customFallbackComponent && b(o.customFallbackComponent), () => e;
};
export {
  f as getComponent,
  p as getCustomFallbackComponent,
  y as getEnableFallbackComponent,
  m as setComponents,
  k as storyblokInit
};
